import { render, staticRenderFns } from "./CampAbout.vue?vue&type=template&id=3046c074&lang=pug&"
import script from "./CampAbout.vue?vue&type=script&lang=js&"
export * from "./CampAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports